export default __webpack_public_path__ + "static/media/icono-autotoma.947457dd.svg";